import { IonIcon, IonButton } from "@ionic/react";

import { close } from "ionicons/icons";

import "./ClosePopoverButton.css";

interface ContainerProps {
  popover: React.RefObject<HTMLIonPopoverElement>;
}

const ClosePopoverButton: React.FC<ContainerProps> = ({
  popover
}) => {

  return (
    <IonButton slot="end" fill="clear" title="Close" onClick={() => popover.current?.dismiss()}>
      <IonIcon icon={close} />
    </IonButton>
  );
};

export default ClosePopoverButton;
